import { Flex } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal';
import { IFiguresAndTablesFile } from '@publishing-engine/domain/models/submission';
import { FormFieldTablesInput } from '@publishing-engine/domain/types/article';
import { TablesEmptyState } from './TablesEmptyState';
import TablesDisplay from './TablesDisplay';

interface Props {
  value?: IFiguresAndTablesFile;
  previousValue?: IFiguresAndTablesFile;
  onClose: () => void;
  config: Omit<FormFieldTablesInput, 'component'>;
}

export const TablesDiffModal = ({
  value,
  previousValue,
  onClose,
  config
}: Props) => {
  const label = config.params.labels.main;
  const hasPrevious = !!previousValue?.length;
  const hasCurrent = !!value?.length;

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        <Flex flexDirection="column" gap={2}>
          {!hasPrevious ? (
            <TablesEmptyState fieldLabels={config.params.labels} />
          ) : (
            <TablesDisplay tables={previousValue} />
          )}
        </Flex>
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        <Flex flexDirection="column" gap={2}>
          {!hasCurrent ? (
            <TablesEmptyState fieldLabels={config.params.labels} />
          ) : (
            <TablesDisplay tables={value} />
          )}
        </Flex>
      </DiffModal.RightSide>
    </DiffModal>
  );
};
